export default {
  "root": "_root_p03wu_1",
  "--radius-none": "_--radius-none_p03wu_1",
  "--radius-small": "_--radius-small_p03wu_1",
  "--radius-medium": "_--radius-medium_p03wu_1",
  "--radius-large": "_--radius-large_p03wu_1",
  "--radius-circular": "_--radius-circular_p03wu_1",
  "--radius-none--m": "_--radius-none--m_p03wu_1",
  "--radius-small--m": "_--radius-small--m_p03wu_1",
  "--radius-medium--m": "_--radius-medium--m_p03wu_1",
  "--radius-large--m": "_--radius-large--m_p03wu_1",
  "--radius-circular--m": "_--radius-circular--m_p03wu_1",
  "--radius-none--l": "_--radius-none--l_p03wu_1",
  "--radius-small--l": "_--radius-small--l_p03wu_1",
  "--radius-medium--l": "_--radius-medium--l_p03wu_1",
  "--radius-large--l": "_--radius-large--l_p03wu_1",
  "--radius-circular--l": "_--radius-circular--l_p03wu_1",
  "--radius-none--xl": "_--radius-none--xl_p03wu_1",
  "--radius-small--xl": "_--radius-small--xl_p03wu_1",
  "--radius-medium--xl": "_--radius-medium--xl_p03wu_1",
  "--radius-large--xl": "_--radius-large--xl_p03wu_1",
  "--radius-circular--xl": "_--radius-circular--xl_p03wu_1"
};import "ni:sha-256;Xq8Td4CZL1FHRebODtzU7Xv468D5LVp7by98Gg0GzV8";